var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
var SnackbarMixin = /** @class */ (function (_super) {
    __extends(SnackbarMixin, _super);
    function SnackbarMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    /**
     * @function SetSnackbarTimeout
     * @description Set the timeout for the snackbar
     * @param timeout Time (in milliseconds) to wait until snackbar is automatically hidden. Use 0 to keep open indefinitely.
     */
    SnackbarMixin.prototype.setSnackbarTimeout = function (timeout) {
        this.store.app.setSnackbarTimeout({ timeout: timeout });
    };
    /**
     * @function ShowSnackbar
     * @description Show the snackbar
     * @param options Options for the snackbar
     */
    SnackbarMixin.prototype.showSnackbar = function (options) {
        this.store.app.showSnackbar({
            text: options.text,
            color: options.color,
        });
    };
    /**
     * @function HideSnackbar
     * @description Hide the snackbar
     */
    SnackbarMixin.prototype.hideSnackbar = function () {
        this.store.app.hideSnackbar();
    };
    SnackbarMixin = __decorate([
        Component
    ], SnackbarMixin);
    return SnackbarMixin;
}(Vue));
export default SnackbarMixin;
